import makeApiCall from "../master/axiosIndex";
const STATIC_FILES_DATA = {
  docKeys: [
    {
      order: 0,
      module: "GRN",
      moduleFileType: "signature.png",
    },
  ],
};

const dispatchApis = {
  submitDispatch: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/dispatch/submitDispatch",
      method: "post",
      data: data,
    }),
  fetchAllDispatches: (): Promise<any> =>
    makeApiCall<any>({
      url: "/dispatch/fetchAllUserGrnPendingDispatches",
      method: "get",
    }),
  fetchDispatch: (id: string): Promise<any> =>
    makeApiCall<any>({
      url: `/dispatch/fetchDispatch?dispatchNumber=${id}`,
      method: "get",
    }),
  fetchAllDispatchesByInvoiceLineNo: (invoiceLineNo: any): Promise<any> =>
    makeApiCall<any>({
      url: `/dispatch/fetchAllDispatchesByInvoiceLineNo?invoiceLineNo=${invoiceLineNo}`,
      method: "get",
    }),
  fetchAllUserDeliveredDispatches: (): Promise<any> =>
    makeApiCall<any>({
      url: "/dispatch/fetchAllUserDeliveredDispatches",
      method: "get",
    }),
  acceptGrn: (dispatchNumber: string, data: any): Promise<any> =>
    makeApiCall<any>({
      url: `/dispatch/acceptGrn/${dispatchNumber}`,
      method: "put",
      data: data,
    }),
  sendGrnEmailNotification: (dispatchNumber: any, data: any): Promise<any> =>
    makeApiCall<any>({
      url: `/dispatch/sendGrnEmailNotification/${dispatchNumber}`,
      method: "post",
      data: data,
    }),
  fetchAllGrnPendingDispatchesWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/dispatch/fetchAllGrnPendingDispatchesWithPagination",
      method: "get",
      params,
    }),
  fetchAllDeliveredDispatchesWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/dispatch/fetchAllDeliveredDispatchesWithPagination",
      method: "get",
      params,
    }),
  fetchAllUserPendingApprovalGrnsWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/dispatch/fetchAllUserPendingApprovalGrnsWithPagination",
      method: "get",
      params,
    }),
  approve: (dispatchNumber: number, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      dispatchNumber,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "patch",
      url: `/dispatch/approveGrn`,
      data: formData,
    });
  },

  reject: (dispatchNumber: number, rejectedReason: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      dispatchNumber,
      rejectedReason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "put",
      url: `/dispatch/disapproveGrn`,
      data: formData,
    });
  },
};

export default dispatchApis;
